export default {
  ReadReport(action, self, onsuccess, onfailed) {
   return {
     data : {
      field: {
        status               : self.state.status,
        type                 : self.state.type,
        owner                : self.state.assigned_to,
        site                 : self.state.site,
        location             : self.state.location,
        purchaser            : self.state.purchased_by,
        start_purchase_date  : self.state.start_purchase_date,
        finish_purchase_date : self.state.finish_purchase_date,
        vendor               : self.state.vendor,
      },
      AuthorizationToken : self.props.UserReducer.token,
     },
     self      : self,
     action    : action,
     onsuccess : self.onReadReportSuccess,
     onfailed  : self.onReadReportFailed,
    }
  },
  ReadAssetTotalValue(action, self, onsuccess, onfailed) {
   return {
     data : {
      field: {
        status               : self.state.status,
        type                 : self.state.type,
        owner                : self.state.assigned_to,
        site                 : self.state.site,
        location             : self.state.location,
        purchaser            : self.state.purchased_by,
        start_purchase_date  : self.state.start_purchase_date,
        finish_purchase_date : self.state.finish_purchase_date,
        vendor               : self.state.vendor,
      },
      AuthorizationToken : self.props.UserReducer.token,
     },
     self      : self,
     action    : action,
     onsuccess : onsuccess,
     onfailed  : onfailed,
    }
  },
  ReadAsMaster(action, self, onsuccess, onfailed) {
   return {
     data : {
       AuthorizationToken : self.props.UserReducer.token,
     },
     action : action,
     self: self,
     onsuccess : self.onReadMasterSuccess,
     onfailed : self.onReadMasterFailed,
    }
  },
  DownloadReport(extension, self, onsuccess, onfailed) {
    return {
      data : {
        doc_type             : extension,
        status               : self.state.status+self.state.status_label,
        type                 : self.state.type+self.state.type_label,
        owner                : self.state.assigned_to+self.state.assigned_to_label,
        site                 : self.state.site+self.state.site_label,
        location             : self.state.location+self.state.location_label,
        purchaser            : self.state.purchased_by+self.state.purchased_by_label,
        start_purchase_date  : self.state.start_purchase_date,
        finish_purchase_date : self.state.finish_purchase_date,
        vendor               : self.state.vendor+self.state.vendor_label,
        AuthorizationToken : self.props.UserReducer.token,
      },
      self: self,
      onsuccess : self.onDownloadSuccess,
      onfailed : self.onDownloadFailed,
     }
  }
}


// WEBPACK FOOTER //
// ./src/App/report/helper/request.props.js